import { Timer } from 'lucide-react';

interface ElapsedTimerProps {
  seconds: number;
  className?: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export function formatElapsedTime(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function ElapsedTimer({ seconds, className }: ElapsedTimerProps) {
  return (
    <div className={`flex items-center gap-1.5 font-mono text-sm ${className ?? ''}`}>
      <Timer className="h-4 w-4" />
      <span>{formatElapsedTime(seconds)}</span>
    </div>
  );
}
